import type { VoidFunctionComponent } from 'react';

import { Icon, icons } from '../../../generic';

import styles from './Invalid.module.less';

/**
 * Renders the "Invalid" state of the Test Dependency card, which is shown when
 * FOSSA is unable to validate the provided dependency revision.
 */
const Invalid: VoidFunctionComponent = () => {
  return (
    <div className={styles.invalid}>
      <Icon icon={icons.warning} size="fa-3x" />
      <div className={styles.header}>
        <p>We couldn&apos;t validate this package</p>
      </div>
      <div className={styles.message}>
        <p>
          This may happen if the name or version is incorrect, or if the package
          doesn&apos;t exist in the selected package manager. You can update the
          details and try again or add the dependency without validating.
        </p>
      </div>
    </div>
  );
};

export default Invalid;
